import { msg } from '@lingui/core/macro';

import { Company } from '@/models/company';

export const STRIPE_STATUS_LABELS: Record<
  Company['stripeAccountStatus'],
  ReturnType<typeof msg>
> = {
  none: msg({
    id: 'settings.organization.invoicing.companies.stripe-status.none',
    message: 'None',
  }),
  onboarding: msg({
    id: 'settings.organization.invoicing.companies.stripe-status.onboarding',
    message: 'Onboarding',
  }),
  pending: msg({
    id: 'settings.organization.invoicing.companies.stripe-status.pending',
    message: 'Pending',
  }),
  complete: msg({
    id: 'settings.organization.invoicing.companies.stripe-status.complete',
    message: 'Complete',
  }),
};
